import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reportmenuslider',
  templateUrl: './reportmenuslider.component.html',
  styleUrls: ['./reportmenuslider.component.css']
})
export class ReportmenusliderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
